// @packages
import Icon from '@material-ui/core/Icon';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import { environment, globalUI } from '../../../../core';
import { config } from '../../../../config';
import { navigateToUrl, appendSessionIdToUrl, navigateToExternalUrl } from '../../../../helpers/global';
// @styles
import styles from './styles';

const CtrlMenuItem = ({
    classes,
    currentUrl,
    icon,
    id,
    isInternal,
    label,
    promptBeforeNavigate,
    sessionId,
    url
}) => {
    const handleClick = (event) => {
        if (isInternal) {
            globalUI.navigateToUrl(url);
        } else if (promptBeforeNavigate) { // When navigating away from FanSizer
            globalUI.showModalDialog({
                msg: config.text.scheduleExitUnsaved.message,
                onConfirm: () => navigateToUrl(appendSessionIdToUrl(url, sessionId)),
                style: environment.isProduction ? { top: event.target.offsetTop } : null,
                title: config.text.scheduleExitUnsaved.title
            });
        } else if (environment.isFromSelNav) {
            navigateToUrl(appendSessionIdToUrl(url, sessionId));
        } else {
            navigateToExternalUrl(url);
        }
    };
    return (
        <MenuItem
            className={classes.menuItem}
            id={id}
            onClick={handleClick}
            selected={currentUrl.startsWith(url)}
        >
            <ListItemIcon>
                <Tooltip title={label} placement="right">
                    <Icon
                        className={classes.menuIcon}
                        color="inherit"
                        id={`${id}-icon`}
                    >
                        {icon}
                    </Icon>
                </Tooltip>
            </ListItemIcon>
            <Typography>
                {label}
            </Typography>
        </MenuItem>
    );
};

CtrlMenuItem.propTypes = {
    classes: PropTypes.object.isRequired,
    currentUrl: PropTypes.string,
    icon: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    isInternal: PropTypes.bool,
    label: PropTypes.string.isRequired,
    promptBeforeNavigate: PropTypes.bool,
    sessionId: PropTypes.string,
    url: PropTypes.string
};

CtrlMenuItem.defaultProps = {
    currentUrl: null,
    isInternal: true,
    promptBeforeNavigate: false,
    sessionId: null,
    url: null
};

export default withStyles(styles)(CtrlMenuItem);
